export const Modal = {
	selectors: {
		modalOpenSelector: Array.prototype.slice.call(document.querySelectorAll('.js-modal--open')),
		modalCloseSelector: Array.prototype.slice.call(document.querySelectorAll('.js-modal--close'))
	},

	init: function() {
		this.autoOpen();
		this.detectOpenedModal();
		this.events();
	},

	events: function() {
		var self = this;

		self.selectors.modalOpenSelector.forEach(function(x) {
			x.addEventListener('click', function(event) {
				event.preventDefault();

				let modalID = self.detectModalSelector(this);

				self.openModal(modalID);

				if (window.DealsMap) {
					window.DealsMap.init();
				}

				if (window.LocationsMap) {
					window.LocationsMap.init();
				}

				// open callback
				if (typeof this.dataset.modalOpenCallback === 'string') {
					eval.call(window, this.dataset.modalOpenCallback);
				}
			});
		});

		self.selectors.modalCloseSelector.forEach(function(x) {
			x.addEventListener('click', function(event) {
				event.preventDefault();

				self.closeModal();
			});
		});

		document.body.addEventListener('click', function(event) {
			if (!event.target.classList.contains('c-modal')) return;

			self.closeModal();
		}, false);
	},

	autoOpen: function() {
		let self = this;
		let modals = Array.prototype.slice.call(document.querySelectorAll(`[data-modal]`));

		modals.forEach(function(x) {
			if (x.dataset.modalAutostart) {
				let time = parseInt(x.dataset.modalAutostart) * 1000;

				setTimeout(function(){
					self.openModal(x.dataset.modal);
				}, time)
			}
		});
	},


	detectModalSelector: function(_selector) {
		let target;

		if (_selector.hasAttribute('data-modal-id')) {
			target = _selector.dataset.modalId;
		} else if (!_selector.dataset.modalId && _selector.hasAttribute('href')) {
			target = _selector.getAttribute('href').split('#').join('');
		}

		return target;
	},

	detectOpenedModal: function() {
		let self = this;

		if (document.querySelector(`.is-open[data-modal]`)) {
			self.openModal(document.querySelector(`.is-open[data-modal]`).dataset.modal);
		}
	},

	openModal: function(_id) {
		var self = this;
		let modal = document.querySelector(`[data-modal='${_id}']`);

		if (modal) {
			document.body.classList.add('is-modal-open');
			modal.classList.add('is-open');
		}
	},

	closeModal: function() {
		var self = this;
		let openedModal = document.querySelector(`.is-open[data-modal]`);

		if (openedModal) {
			document.body.classList.remove('is-modal-open');
			openedModal.classList.remove('is-open');
		}
	}
}

window.Modal = Modal;
Modal.init();
